import script from "./RoomStudents.vue?vue&type=script&setup=true&lang=js"
export * from "./RoomStudents.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__